const BloodGlucoseRecipe = {
    $type$: 'Recipe',
    name: 'BloodGlucose',
    rule: [
        {
            itemprop: 'typeDescription',
            itemtype: { type: 'string' },
            optional: true
        },
        {
            itemprop: 'value',
            itemtype: { type: 'number' }
        },
        {
            itemprop: 'unit',
            itemtype: { type: 'string' },
            optional: true
        },
        {
            itemprop: 'startTimestamp',
            itemtype: { type: 'number' },
            optional: true
        },
        {
            itemprop: 'endTimestamp',
            itemtype: { type: 'number' },
            optional: true
        }
    ]
};
const BloodGlucoseRecipes = [BloodGlucoseRecipe];
export default BloodGlucoseRecipes;
//# sourceMappingURL=BloodGlucoseRecipes.js.map